import { gql } from "apollo-boost";

export const CREATE_DAY_SCHEDULE = gql`
  mutation createDaySchedule(
    $chefId: ID!
    $date: Date
    $dateSchedule: ScheduleForDateInput!
  ) {
    createDaySchedule(chefId: $chefId, date: $date, dateSchedule: $dateSchedule)
  }
`;

export const UPDATE_DATE_SCHEDULE = gql`
  mutation updateDaySchedule(
    $chefId: ID!
    $date: Date!
    $slot: TimeSlotInput!
  ) {
    updateDaySchedule(chefId: $chefId, date: $date, slot: $slot) {
      date
      slots {
        start
        end
      }
    }
  }
`;

export const DELETE_DATE_SCHEDULE = gql`
  mutation deleteSlotForDate(
    $chefId: ID!
    $date: Date!
    $slot: TimeSlotInput!
  ) {
    deleteSlotForDate(chefId: $chefId, date: $date, slot: $slot)
  }
`;

export const CREATE_WEEK_SCHEDULE = gql`
  mutation createSchedule($chefId: ID!, $weekschedule: WeekScheduleInput!) {
    createSchedule(chefId: $chefId, weekschedul: $weekschedule)
  }
`;
export const UPDATE_WEEK_SCHEDULE = gql`
  mutation updateSchedule(
    $chefId: ID!
    $days: [DAY_OF_WEEK]!
    $slot: TimeSlotInput!
  ) {
    updateSchedule(chefId: $chefId, days: $days, slot: $slot) {
      daySchedules {
        day
        slots {
          start
          end
        }
      }
    }
  }
`;

export const DELETE_WEEK_SCHEDULE = gql`
  mutation deleteSlotForDay(
    $chefId: ID!
    $day: DAY_OF_WEEK!
    $slot: TimeSlotInput!
  ) {
    deleteSlotForDay(chefId: $chefId, day: $day, slot: $slot)
  }
`;
